import { api, HttpError } from '../api/client.js';
import { store } from '../state/store.js';
import { navigate } from '../router.js';

export function renderRegister(root: HTMLElement): void {
  root.innerHTML = `
    <div class="auth-shell">
      <div class="auth-card">
        <img src="/img/ui/title.webp" alt="Rex Mortis" style="display:block; margin: 0 auto var(--s-3) auto; width: 280px; max-width: 90%; height: auto;" />
        <h1 style="text-align:center; margin-top:0;">Forge a Character</h1>
        <p class="subtitle" style="text-align:center;">— Choose a name. The realm will remember it —</p>

        <div id="err" class="alert danger" hidden></div>

        <form id="regForm" autocomplete="on">
          <div class="field">
            <label for="characterName">Character name</label>
            <input id="characterName" name="characterName" type="text" required minlength="3" maxlength="20" autocomplete="username" />
            <small class="hint">3–20 chars. Letters, digits, _ or -. Must start with a letter.</small>
          </div>
          <div class="field">
            <label for="email">Email</label>
            <input id="email" name="email" type="email" required autocomplete="email" />
          </div>
          <div class="field">
            <label for="password">Password</label>
            <input id="password" name="password" type="password" required minlength="10" maxlength="72" autocomplete="new-password" />
            <small class="hint">At least 10 characters.</small>
          </div>
          <div class="field" style="margin-top: var(--s-2);">
            <label style="display:flex; align-items:flex-start; gap:8px; font-style: normal;">
              <input id="acceptedTerms" name="acceptedTerms" type="checkbox" required style="margin-top: 4px;" />
              <span style="font-size: 0.9rem; line-height: 1.4;">
                I have read and accept the
                <a href="#/rules" target="_blank" rel="noopener">Rules of the Realm</a>,
                <a href="#/tos" target="_blank" rel="noopener">Terms of Service</a>, and
                <a href="#/privacy" target="_blank" rel="noopener">Privacy Policy</a>.
              </span>
            </label>
          </div>
          <button class="btn" type="submit" id="submit">Step into the Realm</button>
        </form>

        <p class="auth-meta">
          Already have a character? <a href="#/login">Sign in</a>.
        </p>
      </div>
    </div>
  `;

  const form = root.querySelector<HTMLFormElement>('#regForm')!;
  const errBox = root.querySelector<HTMLDivElement>('#err')!;
  const submit = root.querySelector<HTMLButtonElement>('#submit')!;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errBox.hidden = true;
    submit.disabled = true;
    submit.textContent = '…';

    const characterName = (form.elements.namedItem('characterName') as HTMLInputElement).value;
    const email = (form.elements.namedItem('email') as HTMLInputElement).value;
    const password = (form.elements.namedItem('password') as HTMLInputElement).value;
    const acceptedTerms = (form.elements.namedItem('acceptedTerms') as HTMLInputElement).checked;

    if (!acceptedTerms) {
      errBox.textContent = 'You must accept the Rules, Terms of Service, and Privacy Policy to create a character.';
      errBox.hidden = false;
      submit.disabled = false;
      submit.textContent = 'Step into the Realm';
      return;
    }

    try {
      const res = await api.register({ email, password, characterName, acceptedTerms });
      store.set({
        accessToken: res.accessToken,
        account: res.account,
        character: res.character,
      });
      navigate('/profile');
    } catch (err) {
      const msg = err instanceof HttpError ? err.message : 'Could not register.';
      errBox.textContent = msg;
      errBox.hidden = false;
    } finally {
      submit.disabled = false;
      submit.textContent = 'Step into the Realm';
    }
  });
}
